// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueRouter from "vue-router";
import axios from 'axios'
import store from './store'
import sysConfig from './layout/sysConfig'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import CKEditor from '@ckeditor/ckeditor5-vue2';

Vue.use(ElementUI);
Vue.use(CKEditor);

import './utils/elDrag';
import './assets/css/reset.css'
import * as echarts from 'echarts';
import {
  parseTime,
  resetForm,
  addDateRange,
  selectDictLabel,
  selectDictLabels,
  handleTree,
  formatTree,
  isReset
} from "@/utils/tool";
import {getDicts} from "@/api/sys/dict/data";
import request from "./utils/request";
import commons from "./utils/common"

Vue.prototype.sysConfig=sysConfig;
Vue.prototype.axios = axios;
axios.defaults.withCredentials = true;
Vue.prototype.echarts = echarts;
Vue.prototype.handleTree = handleTree;
Vue.prototype.parseTime = parseTime;
Vue.prototype.resetForm = resetForm;
Vue.prototype.addDateRange = addDateRange;
Vue.prototype.selectDictLabel = selectDictLabel;
Vue.prototype.selectDictLabels = selectDictLabels;
Vue.prototype.getDicts = getDicts;
Vue.prototype.formatTree = formatTree;
Vue.prototype.isReset = isReset;
Vue.prototype.commons = commons;


Vue.prototype.msgSuccess = function (msg) {
  this.$message({showClose: true, message: msg, type: "success"});
}

Vue.prototype.msgError = function (msg) {
  this.$message({showClose: true, message: msg, type: "error"});
}

Vue.prototype.msgInfo = function (msg) {
  this.$message.info(msg);
}

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

// Vue.use(permission)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js